export default __webpack_public_path__ + "static/media/twitter-icon.d9f209d1.svg";